import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar"

export interface AvatarUserProps {
  name?: string
  src: string
  className?: string
}

function AvatarUser(props: AvatarUserProps) {
  const splitted = props.name?.split(" ") || []
  const firstAndLastInitials = splitted[0][0] + splitted[splitted.length - 1][0]

  return (
    <Avatar className={props.className}>
      <AvatarImage src={props.src || ""} alt={props.name || ""} />
      <AvatarFallback className="bg-pink-400 text-white">{firstAndLastInitials}</AvatarFallback>
    </Avatar>
  )
}

export default AvatarUser
